import { GridColDef } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import ChipsCell from '@/shared/components/Table/components/ChipsCell/ChipsCell'
import styles from '../../MenuMangementColumns.module.scss'
import { useIngredientsQuery } from '../../Ingredients/hooks/useIngredientsQuery'
import {
  EditableTextCell,
  EditableSelectCell
} from '@/shared/components/Table/components/EditableCell/EditableCell'

export const useIngredientsColumnsConfigInDetailsFrom = () => {
  const { t } = useTranslation()
  const { ingredientsList, unitsList } = useIngredientsQuery()

  const columns: (GridColDef & {
    getPlaceholder?: (params: { row: { id: string } }) => string | undefined
  })[] = [
    {
      field: 'id',
      headerName: 'ID',
      resizable: false,
      width: 44,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      hideable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'dishIngredients',
      headerName: t('TABLE.MENU.HEADERS.NAME'),
      flex: 1,
      editable: false,
      hideable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'dishSizes',
      headerName: t('TABLE.MENU.HEADERS.DISH_SIZES'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => {
        const chipPayload =
          typeof params.value === 'string'
            ? params.value.split(',').map((label, index) => ({
                id: index,
                label: label.trim()
              }))
            : []

        return <ChipsCell chipPayload={chipPayload} />
      }
    },
    {
      field: 'quantity',
      headerName: t('TABLE.MENU.HEADERS.QUANTITY'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,
      type: 'string',
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: EditableTextCell
    },
    {
      field: 'unit',
      headerName: t('TABLE.MENU.HEADERS.UNIT'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      type: 'singleSelect',
      valueOptions: ({ row }) => {
        const ingredient = ingredientsList?.find(ing =>
          row.id.toString().includes(ing.id.toString())
        )
        const ingredientType = unitsList.data?.find(
          u => u.id === ingredient?.unitId
        )?.type
        const sameTypeUnits = unitsList.data?.filter(
          u => u.type === ingredientType
        )
        return (
          sameTypeUnits?.map(u => ({
            value: u.id,
            label:
              u.translations?.find(t => t.languageCode === 'en')?.name || '—'
          })) || []
        )
      },
      getPlaceholder: ({ row }: { row: { id: string } }) => {
        const ingredient = ingredientsList?.find(ing =>
          row.id.toString().includes(ing.id.toString())
        )
        return unitsList.data?.find(u => u.id === ingredient?.unitId)?.type
      },
      renderCell: EditableSelectCell
    }
  ]
  return columns as GridColDef[]
}
